import { useState } from 'react';
import { STICKERS } from '../stickers';

// 😊 button + picker. onPick(key) call hota hai.
export default function StickerPicker({ onPick }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button type="button" onClick={() => setOpen((o) => !o)}
        aria-label="Stickers"
        style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: 20, padding: '4px 6px', lineHeight: 1 }}>
        😊
      </button>
      {open && (
        <>
          <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 40 }} />
          <div style={{
            position: 'absolute', bottom: '100%', right: 0, marginBottom: 6,
            background: '#fff', border: '0.5px solid #C7C5BC', borderRadius: 12,
            boxShadow: '0 6px 24px rgba(0,0,0,.14)', padding: 8, zIndex: 50,
            width: 268, maxHeight: 240, overflowY: 'auto',
            display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 4,
          }}>
            {STICKERS.map((s) => (
              <button key={s.key} type="button" title={s.label}
                onClick={() => { onPick(s.key); setOpen(false); }}
                style={{
                  border: 'none', background: 'none', cursor: 'pointer', padding: 4,
                  borderRadius: 8, lineHeight: 0,
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = '#F1EFE8')}
                onMouseLeave={(e) => (e.currentTarget.style.background = 'none')}
                dangerouslySetInnerHTML={{ __html: `<svg viewBox="0 0 100 100" width="52" height="52">${s.svg}</svg>` }} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
